import axios from 'axios';

export default axios.create({
  baseURL: `https://thingproxy.freeboard.io/fetch/https://www.receitaws.com.br/v1/cnpj/`,
  // responseType: "json"
});
